// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep datatable-body-cell .datatable-body-cell-label {
  display: flex;
}
::ng-deep datatable-body-cell .datatable-body-cell-label span {
  margin: auto 0px;
}
@media screen and (max-width: 500px) {
  ::ng-deep .hideOnMobile {
    display: none !important;
  }
  ::ng-deep datatable-body-cell {
    width: 50% !important;
  }
}

.datatable {
  box-shadow: none;
}
.datatable span {
  font-size: 1rem;
}
.datatable .div-picture {
  position: relative;
  text-align: center;
}
.datatable .div-picture .avatar {
  width: 64px;
  height: 64px;
}
.datatable .div-picture .element {
  position: absolute;
  border-radius: 50px;
  width: 15px;
  height: 15px;
  top: 3px;
  left: 3px;
}
.datatable .div-picture .rouge {
  background-color: #d33630;
}
.datatable .div-picture .vert {
  background-color: #65b045;
}

.div-filter {
  margin-bottom: 15px;
  margin-left: 50px;
}
.div-filter .input-filter {
  margin-left: 15px;
  height: 65px;
  width: 170px;
}

@keyframes fadeIn {
  from {
    background-color: #ffffff;
    color: rgba(2, 165, 29, 0.4);
  }
  to {
    background-color: rgba(2, 165, 29, 0.4);
    color: #ffffff;
  }
}
.buttonclose {
  margin: auto;
}

.buttondelete {
  color: rgba(204, 42, 42, 0.5803921569);
  border: 2px solid rgba(204, 42, 42, 0.5803921569);
  padding: 10px 22px;
  font-weight: 500;
  background: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  margin: auto;
}
.buttondelete:hover {
  color: white;
  background-color: rgba(204, 42, 42, 0.5803921569);
  animation: fadeIt 5s ease-in-out;
}

.buttonedit {
  background-color: rgb(231, 151, 31);
  border: none;
  color: white;
  padding: 10px 22px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  margin-right: 15px;
}

.titels {
  margin: 20px;
  color: #104a64;
}

.highlightedTitle .page-title {
  color: white;
  background: #104a64;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  border-radius: 5px;
  font-size: 1.8rem;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+alerts/see-alerts/see-alerts.component.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAKI;EACE,aAAA;AAJN;AAMM;EACE,gBAAA;AAJR;AASE;EACE;IACE,wBAAA;EAPJ;EAUE;IACE,qBAAA;EARJ;AACF;;AAYA;EACE,gBAAA;AATF;AAWE;EACE,eAAA;AATJ;AAYE;EACE,kBAAA;EACA,kBAAA;AAVJ;AAYI;EACE,WAAA;EACA,YAAA;AAVN;AAaI;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;AAXN;AAcI;EACE,yBAAA;AAZN;AAeI;EACE,yBAAA;AAbN;;AAkBA;EACE,mBAAA;EACA,iBAAA;AAfF;AAiBA;EACI,iBAAA;EACA,YAAA;EACA,YAAA;AAfJ;;AAmBA;EACE;IACE,yBAAA;IACA,4BAAA;EAhBF;EAkBA;IACE,uCAAA;IACA,cAAA;EAhBF;AACF;AAmBA;EACE,YAAA;AAjBF;;AAoBA;EACE,sCAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EAEA,eAAA;EACA,kBAAA;EAEA,YAAA;AAnBF;AAqBE;EACE,YAAA;EACA,iDAAA;EAEA,gCAAA;AAnBJ;;AAuBA;EACE,mCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,YAAA;EACA,cC5Hc;ADwGhB;;AAwBE;EACE,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AArBJ","sourcesContent":["@import \"/src/styles/_variables.scss\";\r\n\r\n\r\n::ng-deep {\r\n  datatable-body-cell {\r\n    .datatable-body-cell-label {\r\n      display: flex;\r\n\r\n      span {\r\n        margin: auto 0px;\r\n      }\r\n    }\r\n  }\r\n  \r\n  @media screen and (max-width: 500px) {\r\n    .hideOnMobile {\r\n      display: none !important;\r\n    }\r\n\r\n    datatable-body-cell {\r\n      width: 50% !important;\r\n    }\r\n  }\r\n}\r\n\r\n.datatable {\r\n  box-shadow: none;\r\n\r\n  span {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .div-picture {\r\n    position: relative;\r\n    text-align: center;\r\n\r\n    .avatar {\r\n      width: 64px;\r\n      height: 64px;\r\n    }\r\n\r\n    .element {\r\n      position: absolute;\r\n      border-radius: 50px;\r\n      width: 15px;\r\n      height: 15px;\r\n      top: 3px;\r\n      left: 3px;\r\n    }\r\n\r\n    .rouge {\r\n      background-color: #d33630;\r\n    }\r\n\r\n    .vert {\r\n      background-color: #65b045;\r\n    }\r\n  }\r\n}\r\n\r\n.div-filter {\r\n  margin-bottom: 15px;\r\n  margin-left: 50px;\r\n\r\n.input-filter {\r\n    margin-left: 15px;\r\n    height: 65px;\r\n    width: 170px;\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    background-color: #ffffff;\r\n    color: #02a51d66;\r\n  }\r\n  to {\r\n    background-color: #02a51d66;\r\n    color: #ffffff;\r\n  }\r\n}\r\n\r\n.buttonclose {\r\n  margin: auto;\r\n}\r\n\r\n.buttondelete {\r\n  color: #cc2a2a94;\r\n  border: 2px solid #cc2a2a94;\r\n  padding: 10px 22px;\r\n  font-weight: 500;\r\n  background: white;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 16px;\r\n  // margin: 4px 2px;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  // margin-right: 15px;\r\n  margin: auto;\r\n\r\n  &:hover {\r\n    color: white;\r\n    background-color: #cc2a2a94;\r\n    -o-animation: fadeIt 5s ease-in-out;\r\n    animation: fadeIt 5s ease-in-out;\r\n  }\r\n}\r\n\r\n.buttonedit {\r\n  background-color: rgb(231, 151, 31);\r\n  border: none;\r\n  color: white;\r\n  padding: 10px 22px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 16px;\r\n  margin: 4px 2px;\r\n  cursor: pointer;\r\n  margin-right: 15px;\r\n}\r\n\r\n.titels {\r\n  margin: 20px;\r\n  color: $primary-color;\r\n}\r\n\r\n.highlightedTitle {\r\n  .page-title {\r\n    color: white;\r\n    background: #104a64;\r\n    width: 100%;\r\n    text-align: center;\r\n    padding: 10px 0;\r\n    border-radius: 5px;\r\n    font-size: 1.8rem;\r\n  }\r\n}\r\n\r\n","// Général\r\n$content-background-color: white;\r\n$primary-color: #104a64;\r\n$success-color: #badbcc;\r\n$success-text-color: #0f5132;\r\n$error-color: #f5c2c7;\r\n$error-text-color: #842029;\r\n$secondary-color: #e9af51;\r\n$secondary-color-light: #e9af51a1;\r\n$danger-color: rgb(255, 79, 79);\r\n$page-title-size: 2.3rem;\r\n$common-size: 1.05rem;\r\n$background-light: #104a64;\r\n\r\n// Header\r\n$width-logo: 145px;\r\n$filter-logo: brightness(0) invert(1);\r\n$header-height: 70px;\r\n$header-color-bottom-border: #cbd3db;\r\n\r\n// Left menu\r\n$left-menu-text-color: white;\r\n\r\n// GED\r\n$ged-background-hover-color: #e9af5128;\r\n$ged-folder-color: $primary-color;\r\n$ged-file-color: $primary-color;\r\n$ged-folder-color-hover: #0056b3;\r\n$ged-file-color-hover: #0056b3;\r\n\r\n// Data Tree\r\n$data-tree-left-menu-width: 300px;\r\n$data-tree-article-title-font-size: 2.8rem;\r\n$data-tree-highlight-color: $secondary-color;\r\n\r\n// See rooms\r\n$see-rooms-title-size: 1.7rem;\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
